export enum VectorStore {
    OracleDb23Ai = 'OracleDb23Ai',
    Heatwave = 'Heatwave',
    Pinecone = 'Pinecone'
}